import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { Gift, Link2, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ReferralNudge() {
  const [status, setStatus] = useState(null);
  const [copied, setCopied] = useState(false);
  const email = localStorage.getItem("fb_sub_email");

  useEffect(() => {
    if (email) {
      axios.get(`${API}/referrals/status`, { params: { email } })
        .then((r) => setStatus(r.data))
        .catch(() => {});
    }
  }, [email]);

  const referralLink = status ? `${window.location.origin}/?ref=${status.referral_code}` : "";

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(referralLink);
      setCopied(true);
      toast.success("Referral link copied — share it anywhere!");
      setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error("Could not copy link");
    }
  };

  return (
    <div className="mt-10 rounded-xl border border-brand-accent/40 bg-accent/5 p-5" data-testid="referral-nudge">
      <div className="flex items-start gap-3">
        <div className="p-2 rounded-full bg-accent/10 shrink-0">
          <Gift size={18} className="text-brand-accent" />
        </div>
        <div className="flex-1 min-w-0">
          {status ? (
            <>
              <p className="font-manrope text-sm font-semibold text-foreground mb-1">
                {status.referral_count > 0
                  ? `You've referred ${status.referral_count} reader${status.referral_count === 1 ? "" : "s"}!`
                  : "Earn free premium by sharing"}
              </p>
              <p className="font-manrope text-xs text-muted-foreground mb-3" data-testid="nudge-progress-text">
                {status.next_milestone
                  ? `${status.next_milestone.remaining} more referral${status.next_milestone.remaining === 1 ? "" : "s"} and you'll earn ${status.next_milestone.label} — free.`
                  : "You've earned every reward. Thank you for spreading the word!"}
              </p>
              <div className="flex flex-wrap items-center gap-2">
                <button
                  onClick={handleCopy}
                  data-testid="nudge-copy-btn"
                  className="inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-brand-accent text-white font-manrope text-xs font-medium hover:bg-brand-accent-hover transition-colors"
                >
                  {copied ? <Check size={12} /> : <Link2 size={12} />}
                  {copied ? "Copied" : "Copy my referral link"}
                </button>
                <Link to="/referrals" data-testid="nudge-referrals-link" className="font-manrope text-xs text-brand-accent hover:underline">
                  See my progress →
                </Link>
              </div>
            </>
          ) : (
            <>
              <p className="font-manrope text-sm font-semibold text-foreground mb-1">
                Enjoying this? Earn free premium.
              </p>
              <p className="font-manrope text-xs text-muted-foreground mb-3">
                Subscribe free, share your link, and unlock premium posts — 3 referrals earns a month of premium.
              </p>
              <div className="flex flex-wrap items-center gap-2">
                <Link
                  to="/subscribe"
                  data-testid="nudge-subscribe-link"
                  className="inline-flex items-center px-3.5 py-1.5 rounded-full bg-brand-accent text-white font-manrope text-xs font-medium hover:bg-brand-accent-hover transition-colors"
                >
                  Subscribe free
                </Link>
                <Link to="/referrals" className="font-manrope text-xs text-brand-accent hover:underline">
                  How it works →
                </Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
